import type { Step } from "react-joyride";

export const qcRecordTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການບັນທຶກ QC! ບັນທຶກ QC (QC Record) ແມ່ນຜົນການກວດສອບທີ່ຖືກບັນທຶກຈາກການນຳໃຊ້ມາດຕະຖານ QC. ທ່ານສາມາດເບິ່ງ, ສ້າງ, ແກ້ໄຂ, ຫຼືລຶບບັນທຶກ QC ໄດ້. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="record-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງບັນທຶກ QC ໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງບັນທຶກ QC ໃໝ່. ທ່ານຈະຕ້ອງເລືອກມາດຕະຖານ QC ທີ່ຕ້ອງການກວດສອບກ່ອນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາບັນທຶກ QC ຕາມຫມາຍເຫດ, ສະຖານທີ່, ປະເພດງານ, ຫຼືສະຖານະ (ຜ່ານ/ບໍ່ຜ່ານ/ກຳລັງກວດສອບ). ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງບັນທຶກ QC ທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ຫຼືລຶບບັນທຶກ QC ໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະບັນທຶກ. ທ່ານຍັງສາມາດກົດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມຂອງບັນທຶກ QC ແຕ່ລະຕົວ.",
    placement: "top",
  },
];
